import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { NgxSliderModule } from '@angular-slider/ngx-slider'
import { I18nModule, UrlModule } from '@spartacus/core'
import { FacetService, IconModule, KeyboardFocusModule } from '@spartacus/storefront'
import { EbFacetComponent } from './eb-facet.component'
import { EbFacetService } from './eb-facet.service'

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    I18nModule,
    IconModule,
    KeyboardFocusModule,
    NgxSliderModule
  ],
  declarations: [EbFacetComponent],
  exports: [EbFacetComponent],
  providers: [
    EbFacetService,
    {
      provide: FacetService,
      useClass: EbFacetService
    }
  ]
})
export class EbFacetModule {}
